import React, { FC, Fragment } from 'react';

import * as Accordion from '@radix-ui/react-accordion';
import clsx from 'clsx';

import { AccordionFilters } from '@domains/products-catalog';

import { StyledCheckboxWithLabel } from '@components/common/StyledCheckboxWithLabel/StyledCheckboxWithLabel';
import { ChevronDownIcon } from '@components/icons';

import styles from './CategoryFiltersAccordion.module.scss';

export type CategoryFiltersAccordionVariant = 'primary' | 'secondary';

export type CategoryFiltersAccordionProps = {
    variant?: CategoryFiltersAccordionVariant;
    data: AccordionFilters;
};

const variantToClassMap: Record<CategoryFiltersAccordionVariant, string> = {
    primary: styles.isVariantPrimary,
    secondary: styles.isVariantSecondary,
};

export const CategoryFiltersAccordion: FC<CategoryFiltersAccordionProps> = (props) => {
    const { data, variant = 'primary' } = props;

    const filters = [
        { name: 'Страна', options: data.countries },
        // «Производитель» renamed to «Торговая марка» (task 302349): the
        // `manufacturers` field now carries brand values supplied by 1C.
        { name: 'Торговая марка', options: data.manufacturers },
    ];

    return (
        <Accordion.Root type="multiple" className={styles.accordionRoot}>
            {filters
                .filter((item) => item.options.length > 0)
                .map(({ name, options }, index) => (
                    <Fragment key={name}>
                        {variant === 'secondary' && index !== 0 && (
                            <hr className={styles.separator} />
                        )}
                        <Accordion.Item
                            value={name}
                            className={clsx(styles.accordionItem, variantToClassMap[variant])}
                        >
                            <Accordion.Header asChild>
                                <Accordion.Trigger
                                    className={clsx(
                                        styles.accordionHeader,
                                        variantToClassMap[variant],
                                    )}
                                >
                                    <span
                                        className={clsx(
                                            styles.filterTitle,
                                            variantToClassMap[variant],
                                        )}
                                    >
                                        {name}
                                    </span>
                                    <ChevronDownIcon className={styles.dropdownIcon} />
                                </Accordion.Trigger>
                            </Accordion.Header>
                            <Accordion.Content asChild>
                                <ul className={styles.filterOptionList}>
                                    {options.map(({ isSelected, label, onSelect }) => (
                                        <li
                                            key={label}
                                            className={clsx(
                                                styles.filterOptionListItem,
                                                variantToClassMap[variant],
                                            )}
                                        >
                                            <StyledCheckboxWithLabel
                                                onChange={onSelect}
                                                isChecked={isSelected}
                                                label={label}
                                            />
                                        </li>
                                    ))}
                                </ul>
                            </Accordion.Content>
                        </Accordion.Item>
                    </Fragment>
                ))}
        </Accordion.Root>
    );
};
